import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Backdrop,
  CircularProgress,
} from '@mui/material';

import { Context } from '../../context/DataContext';
import PhotoField from '../../components/form/PhotoField';
import { getImageFileName, dataURItoBlob } from '../../utils';

const UploadPhotosPage = () => {
  const navigate = useNavigate();
  const [values, setValues] = React.useState({});
  const [errorMsg, setErrorMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const { state, uploadUserPicExt, sendNotification, resetDataContext } =
    React.useContext(Context);
  const {
    customerInfo: { orderId },
  } = state;

  const handlePhotoChange = (prop) => (dataURL) =>
    setValues({
      ...values,
      [prop]: dataURL,
    });

  return (
    <Box sx={{ textAlign: 'center', px: 3, pb: 6 }}>
      <Typography
        variant='h4'
        sx={{ my: 2 }}>
        照片上傳
      </Typography>
      <Box>
        <Typography
          variant='h6'
          sx={{ my: 2 }}>
          {`訂單號碼：${orderId}`}
        </Typography>
        <PhotoField
          label='外盒(有IMEI/SN)'
          placeholder={<p>外盒(有IMEI/SN)</p>}
          onChange={handlePhotoChange('phoneFront')}
        />
        <PhotoField
          label='發票'
          placeholder={<p>發票</p>}
          onChange={handlePhotoChange('invoice')}
        />
        {errorMsg ? (
          <Typography
            variant='h6'
            sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
        <Button
          variant='contained'
          disabled={loading}
          sx={{ width: 168 }}
          onClick={() => {
            // navigate('/extend-new/order-completed');
            const { phoneFront, invoice } = values;

            if (!phoneFront || !invoice) {
              setErrorMsg('請上傳照片');
            } else {
              setLoading(true);
              const phoneFrontName = getImageFileName() + '.jpg';
              const invoiceName = getImageFileName() + '.jpg';

              uploadUserPicExt(
                {
                  orderId,
                  phoneFront: new File(
                    [dataURItoBlob(phoneFront)],
                    phoneFrontName
                  ),
                  phoneFrontName,
                  invoice: new File([dataURItoBlob(invoice)], invoiceName),
                  invoiceName,
                },
                ({ responseCode, responseMsg }) => {
                  if (responseCode === '000') {
                    sendNotification({ orderId }, () =>
                      resetDataContext({ keepTokenLoginInfo: true }, () => {
                        setLoading(false);
                        navigate('/extend-new/order-completed');
                      })
                    );
                  } else {
                    setLoading(false);
                    setErrorMsg(responseMsg);
                  }
                }
              );
            }
          }}>
          下一步
        </Button>
        <Backdrop
          open={loading}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <CircularProgress />
          <Typography
            variant='h6'
            sx={{ my: 2, color: '#9DDCFF' }}>
            上傳中...
          </Typography>
        </Backdrop>
      </Box>
    </Box>
  );
};

export default UploadPhotosPage;
